import { lazy } from 'react'


const ERPProcessMap = lazy(() => import('../../views/apps/processmap/ERP'))

const ProcessMapRoutes = [
    {
        element: <ERPProcessMap />,
        path: '/apps/processmap/ERP'
    }
]

export default ProcessMapRoutes